// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Payroll_EmployeeHistoryInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract for GET /payroll/employee_history
 *
 * Reads user_id and franchise_id (required) plus an optional limit from the
 * query string. user_id and franchise_id are nullable so the controller keeps
 * its existing "user_id e franchise_id obrigatórios" guard (preserving the
 * legacy error message). limit defaults to 10 to match the legacy
 * `$this->input->get('limit') ?? 10` behavior.
 */
import { registerContract } from './validate'

export interface Payroll_EmployeeHistoryInput {
user_id?: string
franchise_id?: number
limit?: number
}

registerContract('Payroll_EmployeeHistoryInput', {
  user_id:      { type: 'string',  required: false },
  franchise_id: { type: 'number',  required: false },
  limit:        { type: 'number',  required: false },
})
